import { CountryCode } from '../../generated-api'

export const mapCountryCodeToCountryName = (countryCode: CountryCode): string => {
    switch (countryCode) {
        case CountryCode.NO:
            return 'Norway'
        case CountryCode.SE:
            return 'Sweden'
        case CountryCode.DK:
            return 'Denmark'
        case CountryCode.UK:
            return 'United Kingdom'
        default:
            return countryCode
    }
}
